import {
  ListItemButton,
  ListItemText,
  Stack,
  SxProps,
  Theme,
  useTheme,
} from '@mui/material'
import { nanoid } from 'nanoid'
import { NavLink } from 'react-router-dom'

import NavItemWithDropdown from '~/layouts/app/header/nav/navItemWithDropdown'
import navItems from '~/layouts/app/utils'

type TProps = {
  colorTrigger: boolean
  sx?: SxProps<Theme>
}

function Nav({ colorTrigger, sx = {} }: TProps) {
  const theme = useTheme()

  const linkStyle = {
    textTransform: 'uppercase',
    fontWeight: 600,
    fontSize: '0.8rem',
    color: colorTrigger ? theme.palette.secondary1 : theme.palette.common.white,
  }

  const style = {
    '& .active': {
      textDecoration: 'underline',
      color: colorTrigger
        ? theme.palette.secondary1
        : theme.palette.common.white,
    },
  }

  return (
    <Stack direction="row" component="nav" sx={{ ...style, ...sx }}>
      {navItems.map((navItem) =>
        navItem.children ? (
          <NavItemWithDropdown
            key={nanoid()}
            navItem={navItem}
            colorTrigger={colorTrigger}
          />
        ) : (
          <ListItemButton
            key={navItem.name}
            component={NavLink}
            to={navItem.path ?? ''}
          >
            <ListItemText
              primaryTypographyProps={{ sx: linkStyle }}
              primary={navItem.name}
            />
          </ListItemButton>
        ),
      )}
    </Stack>
  )
}

export default Nav
